const PRODUCT_TYPE_LABELS = {
  personal_finance: "تمويل شخصي",
  commercial_finance: "تمويل تجاري",
  personal_loan: "قرض شخصي",
  buy_property: "شراء عقار",
  self_build: "بناء ذاتي",
  complete_construction: "إكمال البناء",
  land_loan: "أرض وقرض",
  mortgage: "رهن عقار",
  direct_mortgage: "رهن مباشر",
};

export function formatSaudiMobile(mobile) {
  if (!mobile) return "-";
  const digits = String(mobile).replace(/\D/g, "");
  if (digits.length === 9) return "0" + digits;
  return mobile;
}

export function yesNoLabel(val) {
  if (val === "yes") return "نعم";
  if (val === "no") return "لا";
  return "-";
}

export function productTypeLabel(item) {
  const type = item.selected_product_type || item.product_type;
  if (!type) return "-";
  return PRODUCT_TYPE_LABELS[type] || type;
}

export function formatDateTime(dateStr) {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return dateStr;
  return date.toLocaleString("ar-SA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function isPendingSubmission(item) {
  return item?.status === "pending";
}

export function statusLabel(status) {
  switch (status) {
    case "approved":
      return "موافق عليه";
    case "pending":
      return "قيد المراجعة";
    case "rejected":
      return "مرفوض";
    default:
      return status || "-";
  }
}

export function statusColor(status) {
  switch (status) {
    case "approved":
      return "success";
    case "pending":
      return "warning";
    case "rejected":
      return "error";
    default:
      return "grey";
  }
}
